import React, { FC } from 'react';

import { useAuthContext } from 'state/auth';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useFeaturesLoyaltyTiersContent } from 'state/loyalty/hooks/use-feature-loyalty-tiers-content';
import { useIsLoyaltyEnabled } from 'state/loyalty/hooks/use-is-loyalty-enabled';
import { useLoyaltyRewards } from 'state/loyalty/hooks/use-loyalty-rewards';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';

import { LoyaltyTiersBannerAuthenticated } from './loyalty-tiers-banner-authenticated';
import { LoyaltyTiersBannerUnauthenticated } from './loyalty-tiers-banner-unauthenticated';
import { BannerContainerCompact } from './styled';

interface ILoyaltyTiersCompactBannerProps {
  visible?: boolean;
  displayRewardsLink?: boolean;
  displaySignupLink?: boolean;
}

export const LoyaltyStickyBanner: FC<ILoyaltyTiersCompactBannerProps> = ({
  visible,
  displayRewardsLink,
  displaySignupLink,
}) => {
  const loyaltyEnabled = useIsLoyaltyEnabled();
  const { loyaltyUser, loading: loyaltyLoading } = useLoyaltyUser();
  const { loading: authLoading } = useAuthContext();
  const { enableLoyaltyTiers } = useLoyaltyRewards(loyaltyUser);
  const enableLoyaltyTiersFlag = useFlag(LaunchDarklyFlag.ENABLE_LOYALTY_TIERS);
  const { loading: tiersContentLoading, data: tiersData } = useFeaturesLoyaltyTiersContent();

  const loading = loyaltyLoading || authLoading;

  if (
    !enableLoyaltyTiersFlag ||
    !enableLoyaltyTiers ||
    !loyaltyEnabled ||
    loading ||
    tiersContentLoading ||
    !tiersData?.loyaltyTiersUIConfig
  ) {
    return null;
  }

  return (
    <BannerContainerCompact visible={visible} data-testid="loyalty-tiers-compact">
      {loyaltyUser ? (
        <LoyaltyTiersBannerAuthenticated compact={true} displayRewardsLink={displayRewardsLink} />
      ) : (
        <LoyaltyTiersBannerUnauthenticated compact={true} displaySignupLink={displaySignupLink} />
      )}
    </BannerContainerCompact>
  );
};
